import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Replace these values with your Firebase project config from:
// Firebase Console → Project Settings → General → Your apps → Web app
// Project ID: tsi-explorer
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tsi-explorer.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tsi-explorer",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tsi-explorer.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Request profile & email scopes
googleProvider.addScope('profile');
googleProvider.addScope('email');

// Restrict the Google account chooser to a single Workspace domain.
// This is a UX hint only (pre-fills/filters the account picker) — it is
// NOT a security boundary. The real enforcement happens server-side
// after sign-in (see AuthContext.js), since hd can be bypassed by a
// user editing the request or using a non-Google client.
const ALLOWED_DOMAIN = process.env.REACT_APP_ALLOWED_DOMAIN || '';
if (ALLOWED_DOMAIN) {
  googleProvider.setCustomParameters({ hd: ALLOWED_DOMAIN });
}

export const ALLOWED_HD = ALLOWED_DOMAIN;

export default app;